import logo from "../module/images/mrsingh.png";
const config = {
    //AppScript endPOint for login/registration
    apiEndpoint:"https://script.google.com/macros/s/AKfycbw9aHA4UQ54NDbsLNBhEkwGvClzCbnYUqDVNP22C6DGo-KJvylJh9L3pjpun2S0IY78/exec",
    fallbackImage: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNNLEL-qmmLeFR1nxJuepFOgPYfnwHR56vcw&s",

    backgroundColor: "#070436ff",
    Whatsapp: "https://wa.me/918603592692",
    Linkedin: "https://www.linkedin.com/in/sumit-kumar-915146120/",
    Youtube: "https://youtube.com/@singhgames1070?si=g1r3t4fapLgLLdSk",
    Instagram: "https://www.instagram.com/sumit.kumarsingh036",
    socialMediaIconSize: "30",
    logo: logo,

    projects: [
    {
        title: "Attendance Management Portal (AMP)",
        tech: "React, JavaScript, CSS, Zustand, Tailwind CSS, Google Apps Script",
        description: "A web app for user login, registration, attendance management, and leave reports. Users can apply for leave and view attendance history.",
        codeUrl: "https://github.com/sumitkumar036/sams",
        liveUrl: "https://sumitkumarsingh.online/sams/",
    },
    {
        title: "Library Management System (LMS)",
        tech: "React, JavaScript, CSS, Zustand, Tailwind CSS, Google Apps Script",
        description: "An online platform for managing library books, member tracking, book issuing, and returns. Features include user login, registration, and digital record-keeping.",
        codeUrl: "https://github.com/sumitkumar036/LMS",
        liveUrl: "https://sumitkumarsingh.online/LMS/",
    },
    {
        title: "Showcase Directory",
        tech: "React, JavaScript, CSS, Zustand, Tailwind CSS, Google Apps Script",
        description: "A directory web application designed to showcase projects, resources, or profiles. Features include searchable listings, categorization, and detailed view pages.",
        codeUrl: "https://github.com/sumitkumar036/showcase",
        liveUrl: "https://sumitkumarsingh.online/showcase/",
    }
    // {
    //     title: "Flapper Bird Game",
    //     tech: "Unity 3D, C#",
    //     description: "An Android game developed with Unity 3D and C#. A clone of the classic Flappy Bird game with smooth controls and simple UI.",
    //     codeUrl: "https://github.com/sumitkumar036/flapper-bird-game",
    //     liveUrl: "https://play.google.com/store/apps/details?id=com.GPRNSoftware.FlapperBird&hl=en_IN",
    // },
    ]

}


export default config;